export const environment = {
  debug: false,
  production: true,
  loginPage: "login",
  logoutPage: "logout",
  loginSiteurl: ""
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts